import { BASE_QUERY } from '../base';
export var LANGUAGE_BASE = "\n      " + BASE_QUERY + "\n     name\n     code\n     id\n     isActive\n     description\n     indexId\n";
export var LANG_BASE = "\n      " + BASE_QUERY + "\n     name\n     values\n     prefix\n     isMobileApp\n     env\n     description\n";
export var LANG_BASE_SHORT = "\n     name\n     values\n";
